'use client'

import React, { useState, useEffect } from "react";
import { Snackbar, Button, IconButton } from "@mui/material";
import { einwilligungLesen, einwilligungSetzen, ZUGESTIMMT, ABGELEHNT } from "@/lib/einwilligung";
import CloseIcon from '@mui/icons-material/Close';

export default function CookieConsentBanner() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!einwilligungLesen()) {
            setOpen(true);
        }
    }, []);

    const handleAccept = () => {
        setOpen(false);
        einwilligungSetzen(ZUGESTIMMT);
    };

    const handleReject = () => {
        setOpen(false);
        einwilligungSetzen(ABGELEHNT);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleAccept}>
                Zustimmen
            </Button>
            <Button color="error" size="small" onClick={handleReject}>
                Ablehnen
            </Button>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            onClose={handleClose}
            message="Diese Website speichert ein Cookie mit Ihrer Entscheidung und lädt die Google-Maps-Karte auf der Kontaktseite nur mit Ihrer Zustimmung. Dabei wird Ihre IP-Adresse an Google übermittelt."
            action={action}
            sx={{
                '& .MuiSnackbarContent-root': {
                    backgroundColor: '#333',
                    color: '#fff',
                    flexWrap: 'wrap', // Allow items to wrap in smaller screens
                    maxWidth: 'calc(100vw - 40px)', // Ensure it doesn't exceed viewport width
                    '& .MuiButton-root': {
                        color: '#fff',
                        margin: '4px', // Add spacing around buttons for smaller screens
                    },
                    '& .MuiIconButton-root': {
                        padding: '4px', // Reduce padding for the close icon button
                        margin: '0 4px', // Consistent margin for close icon
                    }
                },
            }}
        />
    );
}
